import LogRocket from 'logrocket';
import * as Sentry from '@sentry/react';
import setupLogRocketReact from 'logrocket-react';
import configuration from 'constants/config';
import { TokenClaims } from 'hooks/ui/useTokenClaims';

type User = {
  _id: string;
  email?: string;
  fullName?: string;
  userType?: string;
};

const shouldRunLogrocketTracking = (user?: User) => {
  const isGreenSite =
    window.location.host.startsWith('www') ||
    window.location.host.startsWith('joinfurther.com');

  const isHeadlessChrome = navigator.userAgent.includes('HeadlessChrome');

  return (
    configuration.STAGE === 'production' &&
    (!isGreenSite || (isGreenSite && user)) &&
    !isHeadlessChrome
  );
};

const shouldRunSentryTracking = () => {
  return configuration.STAGE === 'production';
};

export const initLogrocket = (user?: User, tokenClaims?: TokenClaims) => {
  if (shouldRunLogrocketTracking(user)) {
    LogRocket.init('sq3uml/investor-site', {
      network: {
        requestSanitizer: (request) => {
          try {
            if (request.body) {
              const jsonBody = JSON.parse(request.body);
              if (jsonBody.password) {
                jsonBody.password = '***';
              }
              if (jsonBody.repeatpassword) {
                jsonBody.repeatpassword = '***';
              }
              if (jsonBody.newPassword) {
                jsonBody.newPassword = '***';
              }
              if (jsonBody.repeatNewPassword) {
                jsonBody.repeatNewPassword = '***';
              }
              request.body = JSON.stringify(jsonBody);
            }
            return request;
          } catch (_error) {
            return request;
          }
        },
      },
    });
    if (user) {
      LogRocket.identify(user._id, {
        ...(user.fullName && { name: user.fullName }),
        ...(user.email && { email: user.email }),
        ...(user.userType && { userType: user.userType }),
        ...(tokenClaims?.email && { furtherUserEmail: tokenClaims.email }),
        ...(tokenClaims?.furtherUserId && {
          furtherUserId: tokenClaims?.furtherUserId,
        }),
      });
    }
    setupLogRocketReact(LogRocket);
  }
};

export const initSentry = () => {
  if (shouldRunSentryTracking()) {
    Sentry.init({
      dsn: 'https://0c60065c2f103c7980916c9819d4472b@o4504655840739328.ingest.us.sentry.io/4507017375449088',
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          networkDetailAllowUrls: [/^(?!.*login).*$/],
        }),
      ],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 1,
      replaysOnErrorSampleRate: 1,
      environment: process.env.REACT_APP_STAGE,
      release: process.env.REACT_APP_VERSION_TAG,
    });
  }
};

export const identifySentry = (user: User, tokenClaims: TokenClaims) => {
  if (shouldRunSentryTracking()) {
    Sentry.setUser({
      id: user._id,
      name: user?.fullName,
      email: user.email,
      userType: user?.userType,
      furtherUserEmail: tokenClaims?.email,
      furtherUserId: tokenClaims?.furtherUserId,
    });
  }
};
